import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import Coordinate from '../../geom/Coordinate';
import NodeBase from './NodeBase';
import Node from './Node';
import IntervalSize from './IntervalSize';
import Assert from '../../util/Assert';
var Root = /*#__PURE__*/function (_NodeBase) {
  _inherits(Root, _NodeBase);
  function Root() {
    _classCallCheck(this, Root);
    return _possibleConstructorReturn(this, _getPrototypeOf(Root).call(this));
  }
  _createClass(Root, [{
    key: "insert",
    value: function insert(itemEnv, item) {
      var index = NodeBase.getSubnodeIndex(itemEnv, Root.origin.x, Root.origin.y);
      if (index === -1) {
        this.add(item);
        return null;
      }
      var node = this._subnode[index];
      if (node === null || !node.getEnvelope().contains(itemEnv)) {
        var largerNode = Node.createExpanded(node, itemEnv);
        this._subnode[index] = largerNode;
      }
      this.insertContained(this._subnode[index], itemEnv, item);
    }
  }, {
    key: "isSearchMatch",
    value: function isSearchMatch(searchEnv) {
      return true;
    }
  }, {
    key: "insertContained",
    value: function insertContained(tree, itemEnv, item) {
      Assert.isTrue(tree.getEnvelope().contains(itemEnv));
      var isZeroX = IntervalSize.isZeroWidth(itemEnv.getMinX(), itemEnv.getMaxX());
      var isZeroY = IntervalSize.isZeroWidth(itemEnv.getMinY(), itemEnv.getMaxY());
      var node = null;
      if (isZeroX || isZeroY) node = tree.find(itemEnv);else node = tree.getNode(itemEnv);
      node.add(item);
    }
  }]);
  return Root;
}(NodeBase);
export { Root as default };
Root.origin = new Coordinate(0.0, 0.0);